import { Navigate } from 'react-router';
import { LegalPage } from '../../components/legal-page';
import { OFFER } from '../../content/legal';
import { countryConfig } from '../../country';
import { ES_LEGAL_PATHS, hasEsLegalSet } from '../../content/legal/es/paths';

/** /offer — публичная оферта / пользовательское соглашение. Public. */
export function Offer() {
  // MiLicita (`es`) never renders the UZ/KZ оферта: its own Spanish terms live at
  // /condiciones (the router already redirects there; this is the backstop).
  if (hasEsLegalSet(countryConfig.code)) {
    return <Navigate to={ES_LEGAL_PATHS.condiciones} replace />;
  }
  return <LegalPage doc={OFFER} canonical="/offer" />;
}
